export function StatusBadge({ status }) {
  const s = (status || '—').toString();
  const key = s.toLowerCase();
  let cls = 'bg-slate-100 text-slate-700';
  if (key.includes('sync')) cls = 'bg-emerald-100 text-emerald-800';
  else if (key.includes('pending') || key.includes('draft')) cls = 'bg-amber-100 text-amber-900';
  else if (key.includes('fail') || key.includes('reject')) cls = 'bg-red-100 text-red-800';

  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {s}
    </span>
  );
}
